module.exports = __webpack_public_path__ + "assets/img/wei2.dc180d81.png";